// extracted by mini-css-extract-plugin
export var aircallIframe = "_m7-3";
export var fabContainer = "_m7-5";
export var fabRinging = "_m7-6";
export var loadingOverlay = "_m7-4";
export var pulse = "_m7-7";
export var widgetContent = "_m7-2";
export var widgetPanel = "_m7-0";
export var widgetPanelExpanded = "_m7-1";